<template>
  <div>
    <card :preview="preview"></card>
  </div>
</template>

<script>
import card from "../../../stempcore/src/core/components/common/Card.vue";
export default {
  components: {
    card
  },
  data() {
    return {
      preview: "preview"
    };
  },
  // mounted() {
  //   console.log(this.preInfo);
  // },
  methods: {}
};
</script>
<style lang="scss" scoped></style>
